import React from 'react';
import styles from './styles/ESASection.module.css';

export default function ESASection() {
  return (
    <section className={styles.esaSection}>
      <div className={styles.esaContent}>
        <h2 className={styles.esaHeading}>
          Use your ESA funds on PenguinLearn where eligible
        </h2>
        <p className={styles.esaCopy}>
          PenguinLearn is working with ESA programs so families can use
          education savings to join live online classes.
        </p>
        <a href="/footer/esa" className={styles.esaLearnMore} >ESA</a>
      </div>

      <div className={styles.esaPenguinWrapper}>
        <img
          src="/images/penguin2.png"
          alt="PenguinLearn mascot"
          className={styles.esaPenguin}
        />
      </div>
    </section>
  );
}